import { useEffect, useState } from "react";

const FALLBACK_ITEMS = [
  { tag: "deadline", text_en: "EU PPWR applicable since 12 Aug 2026", text_hi: "EU PPWR 12 अगस्त 2026 से लागू", link: "" },
  { tag: "update", text_en: "India: non-ferrous scrap and C&D EPR live since 1 Apr 2026", text_hi: "भारत: नॉन-फेरस स्क्रैप और C&D EPR 1 अप्रैल 2026 से लाइव", link: "" },
  { tag: "alert", text_en: "CPCB recovering Environmental Compensation on past shortfalls", text_hi: "CPCB पिछली कमियों पर Environmental Compensation वसूल रहा है", link: "" },
  { tag: "deadline", text_en: "California SB 54 reporting begins 2027", text_hi: "California SB 54 रिपोर्टिंग 2027 से शुरू", link: "" },
  { tag: "notice", text_en: "Early access to the EPR Control Portal opens October 2026", text_hi: "EPR कंट्रोल पोर्टल का अर्ली एक्सेस अक्टूबर 2026 में", link: "" },
  { tag: "update", text_en: "Oregon and Colorado already invoicing producers", text_hi: "Oregon और Colorado प्रोड्यूसर्स को इनवॉइस भेज रहे हैं", link: "" },
];

const TAG_STYLES = {
  deadline: "border-amber-400/40 bg-amber-400/10 text-amber-300",
  alert: "border-red-400/40 bg-red-400/10 text-red-300",
  update: "border-emerald-400/40 bg-emerald-400/10 text-emerald-300",
  notice: "border-sky-400/40 bg-sky-400/10 text-sky-300",
};

const TAG_LABELS = {
  en: { deadline: "DEADLINE", alert: "ALERT", update: "UPDATE", notice: "NOTICE" },
  hi: { deadline: "डेडलाइन", alert: "अलर्ट", update: "अपडेट", notice: "सूचना" },
};

export default function LiveTicker() {
  const [items, setItems] = useState(FALLBACK_ITEMS);

  useEffect(() => {
    let alive = true;
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/ticker`)
      .then((r) => r.json())
      .then((data) => {
        if (alive && data.source === "db" && Array.isArray(data.items)) setItems(data.items);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  if (items.length === 0) return null;

  const row = [...items, ...items];

  const renderItem = (item, rowIndex, isCopy) => {
    const i = rowIndex % items.length;
    const text = item.text_en;
    const inner = (
      <>
        <span
          className={`rounded-full border px-2.5 py-0.5 font-mono text-[9px] font-bold uppercase tracking-[0.18em] ${TAG_STYLES[item.tag] || TAG_STYLES.update}`}
          data-testid={isCopy ? undefined : `ticker-tag-${i}`}
        >
          {TAG_LABELS.en[item.tag] || TAG_LABELS.en.update}
        </span>
        <span className="text-sm font-medium text-emerald-50/90" data-testid={isCopy ? undefined : `ticker-item-${i}`}>
          {text}
        </span>
        <span className="h-1.5 w-1.5 rounded-full bg-emerald-500/40" />
      </>
    );
    const cls = "flex items-center gap-3";
    return item.link ? (
      <a
        key={rowIndex}
        href={item.link}
        target={item.link.startsWith("http") ? "_blank" : undefined}
        rel={item.link.startsWith("http") ? "noreferrer" : undefined}
        className={`${cls} transition-opacity hover:opacity-75`}
        data-testid={isCopy ? undefined : `ticker-link-${i}`}
      >
        {inner}
      </a>
    ) : (
      <span key={rowIndex} className={cls}>
        {inner}
      </span>
    );
  };

  return (
    <section data-testid="live-ticker" aria-label="EPR Wire" className="relative flex items-stretch overflow-hidden border-y border-emerald-950/20 bg-forest-deep">
      <div className="relative z-10 flex shrink-0 items-center gap-2 bg-forest-deep py-2.5 pl-4 pr-4 sm:pl-6 shadow-[10px_0_18px_rgba(6,38,21,1)]">
        <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 animate-pulse-dot" />
        <span className="font-mono text-[10px] font-bold uppercase tracking-[0.22em] text-emerald-300" data-testid="ticker-wire-label">
          EPR Wire · Live
        </span>
      </div>
      <div className="marquee-track flex w-max items-center gap-8 whitespace-nowrap py-2.5 pr-8">
        {row.map((item, i) => renderItem(item, i, i >= items.length))}
      </div>
    </section>
  );
}
